import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import * as untypedI18n from '../i18n';
var i18n = untypedI18n;

var getCodesFromLocale = function getCodesFromLocale(locale) {
  var match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');

  if (!match) {
    throw Error('Unable to get language and country from invalid Locale');
  }

  var _match = _slicedToArray(match, 3),
      language = _match[1],
      country = _match[2];

  return {
    language: language.toLowerCase(),
    country: country.toUpperCase()
  };
};

export var PaginatedPickerIntlProvider = function PaginatedPickerIntlProvider(_ref) {
  var children = _ref.children;
  var intl = useIntl();

  var _getCodesFromLocale = getCodesFromLocale(intl.locale.toString()),
      language = _getCodesFromLocale.language,
      country = _getCodesFromLocale.country;

  var messages = i18n["".concat(language, "_").concat(country)] || i18n[language] || i18n.en;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    messages: messages,
    locale: intl.locale
  }, children);
};